import Button from 'components/UI/Button';
import { useModal } from 'hooks';
import {
    AUTH_MODAL,
} from '_constants/modalTypes';

import StyledConnection from './styles';

const Connection = ({ t }) => {
    const {
        onOpen: onModalOpen,
    } = useModal();
    const openAuthModal = () => onModalOpen(AUTH_MODAL);

    return (
        <StyledConnection>
            <h2>
                Connect your wallet to access allocations menu.
            </h2>
            <Button onClick={openAuthModal}>{t('connectWalletButton')}</Button>
        </StyledConnection>
    );
};

export default Connection;
